// OSRS curve, mirrored client-side for progress bars. Server is authoritative for levels.
const table: number[] = [0];
for (let lvl = 2; lvl <= 99; lvl++) {
  let sum = 0;
  for (let x = 1; x < lvl; x++) sum += Math.floor(x + 300 * Math.pow(2, x / 7));
  table.push(Math.floor(sum / 4));
}

export function xpForLevel(level: number): number {
  return table[Math.min(Math.max(level, 1), 99) - 1];
}

export function levelForXp(xp: number): number {
  let l = 1;
  while (l < 99 && table[l] <= xp) l++;
  return l;
}

/** Progress through the current level, 0..1. */
export function levelProgress(xp: number): {
  level: number;
  into: number;
  span: number;
  pct: number;
} {
  const level = levelForXp(xp);
  if (level >= 99) return { level, into: 0, span: 1, pct: 1 };
  const lo = xpForLevel(level);
  const hi = xpForLevel(level + 1);
  return { level, into: xp - lo, span: hi - lo, pct: (xp - lo) / (hi - lo) };
}

export function fmtXp(n: number): string {
  return n.toLocaleString("en-GB");
}
